import { ContentRow as ImportedContentRow} from "vl-app-client/lib/cms/contentInterfaces";
export * from "vl-app-client/lib/cms/contentInterfaces";
export * from "vl-app-client/lib/cms/schema/directives";
export * from "vl-app-client/lib/cms/schema/scalars";
export interface ContentRow extends ImportedContentRow{
    createdAt: string;
}

